/* eslint-disable no-var */
import { enableProdMode, Injector } from "@angular/core";

import { environment } from "./environments/environment";

declare global {
    var FIREBASE_APPCHECK_DEBUG_TOKEN: boolean | string | undefined;
    var HubSpotConversations: {
        on: (event: string, callback: (...args: any[]) => void) => void;
        off: (event: string, callback: () => void) => void;
        widget: {
            load: (...args: unknown[]) => void;
            refresh: (...args: unknown[]) => void;
            open: (...args: unknown[]) => void;
            close: (...args: unknown[]) => void;
            remove: (...args: unknown[]) => void;
            status: (...args: unknown[]) => void;
        };
    };
    var hsConversationsOnReady: (() => void)[] | undefined;
    var hsConversationsSettings: {
        loadImmediately?: boolean;
        inlineEmbedSelector?: string;
        enableWidgetCookieBanner?: boolean;
        disableAttachment?: boolean;
        identificationToken?: string;
        identificationEmail?: string;
        avoidInlineStyles?: boolean;
        disableInitialInputFocus?: boolean;
    };
}

if (environment.production) {
    enableProdMode();
    window.console.log = (): void => {
        // do nothing.
    };
    window.console.group = (): void => {
        // do nothing.
    };
    window.console.groupEnd = (): void => {
        // do nothing.
    };
    window.console.info = (): void => {
        // do nothing.
    };
}

import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";

let appInjectorRef: Injector;
export const appInjector = (injector?: Injector): Injector => {
    if (injector) {
        appInjectorRef = injector;
    }

    return appInjectorRef;
};

bootstrapApplication(AppComponent, appConfig)
    .then((appRef) => {
        appInjector(appRef.injector);
    })
    .catch((err) => console.error(err));
